import React, { useMemo } from 'react';
import { mapCheckedValues } from '../utils/map-checked-values';
import { activeItemSelected } from '../utils/selected-value';
import { LinkCodesTranslation } from '../constants';
import {
  useDetailsSelectors, useMetadataSelectors, useLoadRootLevelListEffect,
  useListActionsSelectors, useListActionsCallbacks, useListBranchSelectors, useListBranchCallbacks,
  useListSelectors, useListCallbacks
} from '../hooks';
import { Visibility } from '../types-store';
import { ListHeader } from './list-header';
import { ListItems } from './list-items';

import styles from './link-codes-results.scss';
import { getCurrentBranchItems } from 'app/area/link-codes/utils/get-current-branch-items';
import { ElementLoader } from 'ui';

interface LinkCodesResultsProps {
  hasChanges: boolean;
  translation: LinkCodesTranslation;
}

export const LinkCodesResults: React.FC<LinkCodesResultsProps> = ({
  hasChanges, translation
}) => {

  useLoadRootLevelListEffect();

  const { listBranch, listBranchState } = useListBranchSelectors();
  const { listActions } = useListActionsSelectors();
  const { codetableValue, categoryValue, activeValue, activeType } = useDetailsSelectors();
  const { metadata } = useMetadataSelectors();
  const { visiblity, selectedRows } = useListSelectors();
  const { selectRow } = useListCallbacks();

  const {
    loadFromParent,
    expandListBranchItem
  } = useListBranchCallbacks();

  const { addListAction } = useListActionsCallbacks();

  const checkedValues = useMemo(
    () => mapCheckedValues(listBranch, listActions, activeItemSelected(activeValue, activeType)),
    [listBranch, listActions, activeValue?.value]
  );
  const id = 0;
  const currentBrunchItems = getCurrentBranchItems(id, listBranch, checkedValues, visiblity);
  const numberOfResults = listBranch?.find(branch => branch.id === 0)?.numberOfResults ?? 0;
  const fetching = listBranchState.findIndex(item => item.fetching) === -1;

  return (!!codetableValue?.value &&
    (!metadata?.category?.id || !!categoryValue?.value) &&
    !!activeValue?.value) ? <>
    <ListHeader
      hasChanges={hasChanges}
      displayNumberOfResults={visiblity === Visibility.all && listBranch?.length > 0}
      numberOfResults={numberOfResults}
      translation={translation} />
    {(numberOfResults > 0 && currentBrunchItems.length > 0)
      ? <div className={styles.listItemsContainer}>
        <div className={styles.listItems}>
          <ListItems
            listBranch={listBranch}
            listBranchState={listBranchState}
            visiblity={visiblity}
            checkedValues={checkedValues}
            selectedRows={selectedRows}
            path={[]}
            hierarchyMode={!!metadata?.hierarchy}
            hierarchyMetadata={[]}
            isZebra={undefined}
            expandItem={expandListBranchItem}
            selectRow={selectRow}
            addAction={addListAction}
            loadFromParent={loadFromParent}
            translation={translation} />
        </div>
      </div> : (fetching ? <p id="link_codes_number_of_results">{translation.search_no_hits}</p> : <ElementLoader />)}
  </> : <p className="no-content">{translation.no_values}</p>;
};
